import Modal from "react-bootstrap/Modal";
import garbage from "../../..//assets/images/garbage.svg";
import { userService } from "services";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function DeleteAccount({ show, handleClose }) {

    const navigate = useNavigate()

    const deleteAccount = async (payload) => {
        try {
            const response = await userService.deleteAccount(payload)
            localStorage.clear();
            navigate('/login');
            toast.success(response?.data?.message)
        }
        catch (err) {
            console.log(err?.response?.data)
        }
    }
    return (
        <Modal
            show={show}
            className="modal-common delete-pop"
            onHide={handleClose}
        >
            <Modal.Body>
                <div className="text-center">
                    <div className="garbage-box d-flex justify-content-center align-items-center">
                        <img alt="" src={garbage} />
                    </div>
                    <h2 className="mb-3">Delete account</h2>
                    <p>Are you sure you want to delete your account</p>
                    <div className="d-flex flex-wrap gap-2 mt-4">
                        <button onClick={handleClose} className="btn blue-btn">
                            No
                        </button>
                        <button onClick={deleteAccount} className="btn gray-btn">
                            Yes
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default DeleteAccount;
